import api from "@/api";

export default {
  namespaced: true,
  state: {
    assignments: [],
    currentAssignment: null,
    isLoading: false,
    error: null,
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
      from: 0,
      to: 0,
    },
    filters: {
        search: "",
      class_id: null,
      group_id: null,
      subject_id: null,
      teacher_id: null,
    },
  },
  mutations: {
    SET_ASSIGNMENTS(state, assignments) {
      state.assignments = assignments;
    },
    SET_CURRENT_ASSIGNMENT(state, assignment) {
      state.currentAssignment = assignment;
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_PAGINATION(state, pagination) {
      state.pagination = pagination;
    },
    SET_FILTERS(state, filters) {
      state.filters = filters;
    },
    ADD_ASSIGNMENT(state, assignment) {
      state.assignments.unshift(assignment);
    },
    UPDATE_ASSIGNMENT(state, updatedAssignment) {
      const index = state.assignments.findIndex(
        (a) => a.id === updatedAssignment.id
      );
      if (index !== -1) state.assignments.splice(index, 1, updatedAssignment);
    },
    DELETE_ASSIGNMENT(state, assignmentId) {
      state.assignments = state.assignments.filter((a) => a.id !== assignmentId);
    },
  },
  actions: {
      async fetchAssignments({ commit, state }, { page = 1, per_page = 10 } = {}) {
      commit("SET_LOADING", true);
      try {
        const response = await api.get("/assignments", {
          params: {
            page: page || state.pagination.currentPage,
            per_page: per_page || state.pagination.perPage,
            search: state.filters.search,
            class_id: state.filters.class_id,
            subject_id: state.filters.subject_id,
            teacher_id: state.filters.teacher_id,
          },
        });

        commit("SET_ASSIGNMENTS", response.data.data);
        commit("SET_PAGINATION", {
          currentPage: response.data.meta.current_page,
          totalPages: response.data.meta.last_page,
          totalItems: response.data.meta.total,
          perPage: response.data.meta.per_page,
          from: response.data.meta.from,
          to: response.data.meta.to,
        });
      } catch (error) {
        commit("SET_ERROR", error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    
    async fetchAssignment({ commit }, id) {
      commit("SET_LOADING", true);
      try {
        const response = await api.get(`/assignments/${id}`);
        commit("SET_CURRENT_ASSIGNMENT", response.data.data);
      } catch (error) {
        commit("SET_ERROR", error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async createAssignment({ commit }, assignmentData) {
      commit("SET_LOADING", true);
      try {
        const response = await api.post("/assignments", assignmentData);
        commit("ADD_ASSIGNMENT", response.data.data);
        return response.data;
      } catch (error) {
        if (error.response && error.response.status === 422) {
          throw error.response.data.errors;
        }
        commit("SET_ERROR", error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async updateAssignment({ commit }, { id, assignmentData }) {
      commit("SET_LOADING", true);
      try {
        const response = await api.put(`/assignments/${id}`, assignmentData);
        commit("UPDATE_ASSIGNMENT", response.data.data);
        return response.data;
      } catch (error) {
        if (error.response && error.response.status === 422) {
          throw error.response.data.errors;
        }
        commit("SET_ERROR", error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async deleteAssignment({ commit }, id) {
      commit("SET_LOADING", true);
      try {
        await api.delete(`/assignments/${id}`);
        commit("DELETE_ASSIGNMENT", id);
      } catch (error) {
        commit("SET_ERROR", error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    setFilters({ commit, dispatch }, filters) {
      commit("SET_FILTERS", filters);
      dispatch("fetchAssignments", { page: 1 });
    },
  },
  getters: {
    assignments: (state) => state.assignments,
    assignment: (state) => state.currentAssignment,
    isLoading: (state) => state.isLoading,
    error: (state) => state.error,
    pagination: (state) => state.pagination,
  },
};